'use client';

import useDynamicTranslation from '@/hooks/useDynamicTranslation';
import { RootState } from '@/store';
import { useSelector } from 'react-redux';

export default function PolicyPage() {
  const { dt } = useDynamicTranslation();
  const { general } = useSelector((state: RootState) => state.settings);

  const policies = [
    {
      key: 'terms_of_service',
      content: general?.terms_conditions,
    },
    {
      key: 'privacy_policy',
      content: general?.privacy_policy,
    },
    {
      key: 'shipping_delivery_policy',
      content: general?.shipping_delivery_policy,
    },
    {
      key: 'return_policy',
      content: general?.return_policy,
    },
  ].filter((policy) => policy.content); // Only include policies with content

  return (
    <div className="container">
      <div className="contentWrapper">
        {/* Header Section */}
        <div className="header">
          <h1 className="headerTitle">{dt('policies')}</h1>
        </div>

        {/* Policy Sections */}
        {policies.map((policy) => (
          <div key={policy.key} id={policy.key} className="policySection">
            <h4 className="policyTitle">{dt(policy.key)}</h4>
            <div
              className="policyContent"
              dangerouslySetInnerHTML={{ __html: policy.content }}
            />
          </div>
        ))}
      </div>

      <style jsx>{`
        .container {
          max-width: 100vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #f8fafc;
          min-height: 100vh;
        }

        .contentWrapper {
          padding: 40px 20px;
          max-width: 1200px; /* Narrower for better readability */
          display: flex;
          flex-direction: column;
          gap: 4rem;
        }

        .header {
          text-align: center;
          margin-bottom: 1rem;
        }

        .headerTitle {
          font-size: 2.5rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 0.5rem;
        }

        .policySection {
          display: flex;
          flex-direction: column;
          align-items: start;
          border-bottom: 1px solid #e5e7eb;
          padding-bottom: 2rem;
        }

        .policyTitle {
          font-size: 1.5rem;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 1rem;
          transition: color 0.2s ease;
        }

        .policyContent {
          text-align: start;
          font-size: 0.9em;
          color: var(--body-color);
          line-height: 1.75;
        }

        /* Responsive Styles */
        @media (max-width: 768px) {
          .contentWrapper {
            padding: 20px 10px;
          }

          .headerTitle {
            font-size: 2rem;
          }

          .policyTitle {
            font-size: 1.25rem;
          }

          .policyContent {
            font-size: 0.938rem;
          }
        }
      `}</style>
    </div>
  );
}
